<template>
    <div class="flex flex-col items-center justify-items-center lg:px-64 md:px-32 sm:px-16 px-3 mb-40">
        <h2 class="mt-16 mb-10 tracking-wider font-semibold text-center text-3xl">{{ $route.params.title }}</h2>
        <tailwind-image
            v-if="linkExists(0)"
            :link="links[0]"
            aspect-ratio="7/12"
            class="w-full"
        ></tailwind-image>
        <div class="mt-5">
            <div class="mt-10">
                <p>Der Entwurf für das Rechenzentrum MainCube für den Standort EVO Offenbach wurde von Markus Holzbach in den Leistungsphasen 1-4 incl. Bauvoranfrage für die innovit AG entwickelt. Mit den modularen Erweiterungsmöglichkeiten sowie den stützenfreien Serverräumen und dem einbeschriebenen Grundriss in Form eines griechischen Kreuzes wurde das - für den Standort EVO Offenbach konzipierte - Rechenzentrum MainCube als innovatives Rechenzentrumskonzept in der Rubrik „Visionäre Rechenzentrumsarchitektur“ mit dem Deutschen Rechenzentrumspreis ausgezeichnet.</p>

                <p>Der MainCube ist als Konzept speziell auf die Bedürfnisse von Großrechenzentrums-Betreibern und Hosting-Anbietern abgestimmt und bietet hohe Flexibilität bei der Erweiterung von RZ-Flächen. Durch sein neuartiges Raumkonzept bietet es maximale Raumeffizienz und die Möglichkeit zum optimalen Einsatz energieeffizienter Technologien. Die Außenfassade vereinigt die funktionellen Aspekte modernster Klimatechnologie mit grünen Technologien und einem Bepflanzungskonzept, welche als städtebaulicher Impuls für die Stadtentwicklung im nördlichen Offenbach konzipiert wurde. Das Designkonzept des Rechenzentrums ermöglicht den Einsatz der energiesparenden und umweltfreundlichen direkten freien Kühlung mit Rotationswärmetauschern. Durch die effiziente Struktur und Anordnung der Räume werden Technikflächen reduziert und der Anteil der nutzbaren Serverfläche maximiert. Außerdem erlaubt der modulare Aufbau des Gebäudes einen reibungslosen stufenweisen Ausbau der Rechenzentrums-Flächen und die individuelle Ausgestaltung einzelner Teilbereiche. Dadurch lassen sich unterschiedliche Anforderungen hinsichtlich Verfügbarkeit und Sicherheit innerhalb eines oder mehrerer MainCube realisieren. </p>
            </div>
        </div>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(1)"
                :link="links[1]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(2)"
                :link="links[2]"
                aspect-ratio="9/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-if="linkExists(3)"
            :link="links[3]"
            aspect-ratio="8/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(4)"
                :link="links[4]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(5)"
                :link="links[5]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-if="linkExists(6)"
            :link="links[6]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <tailwind-image
            v-for="iLink in allRemainingLinks"
            :key="'VueKey' + iLink"
            :link="iLink"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <span class="mt-5 w-full text-left">
            <p class="font-semibold">Entwurf</p>
            <p>Markus Holzbach Architektur</p>
        </span>

    </div>
</template>
<script>
import TailwindImage from '@/components/TailwindImage';


export default {
    components: {
        TailwindImage,
    },
    props: {},
    data ()
    {
        return {
            links: [
                require( '@/assets/img/pc/maincube_1.jpg' ),
                require( '@/assets/img/pc/rechenzentrumspreis.jpg' ),
                require( '@/assets/img/pc/2011-03-28 Rechenzentrum Main Cube EVO Offenbach.jpg' ),
                require( '@/assets/img/pc/Visualisierung blau1-klein.jpg' ),
                require( '@/assets/img/pc/maincube_5.jpg' ),
                require( '@/assets/img/pc/maincube_4.jpg' ),
            ],
        };
    },
    methods: {
        linkExists ( index )
        {
            return index in this.links;
        }
    },
    created () { },
    computed: {
        allRemainingLinks ()
        {
            if ( !this.linkExists( 7 ) )
            {
                return [];
            } else
            {
                return this.links.slice( 7 );
            }
        }
    }
};
</script>